var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-language-code-field',{attrs:{"input":_vm.input,"disabled":_vm.disabled,"languages":_vm.languages,"code-types":_vm.codeTypes},on:{"update":function($event){return _vm.$emit('update', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }